'use client';
import React from 'react';
import { useTranslations } from '../utils/translations';

export default function UnderlayScrollerSection() {
  const { t } = useTranslations();
  
  return (
    <section className="w-full relative">
      {/* Container with clip-path for iOS compatibility */}
      <div 
        className="relative w-full"
        style={{ 
          clipPath: 'inset(0)',
          position: 'relative'
        }}
      >

        {/* Transparent window with fixed background */}
        <div 
          className="relative mx-auto h-[250px] md:h-[400px] flex items-center justify-center"
        >
          {/* Fixed mystical universe background */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: -1,
              backgroundImage: 'url(https://www.madriel.cz/bg-image-002.jpeg)'
            }}
          />
          
          {/* Centered title */}
          <h2 
            className="text-center px-4 text-[24px] sm:text-[32px] md:text-[40px] lg:text-[48px] font-bold leading-tight"
            style={{ 
              color: '#FFFFFF',
              fontFamily: 'MedievalSharp, serif'
            }}
          >
            {t('home.underlay_scroller.heading')}
          </h2>
        </div>
      </div>
    </section>
  );
}